import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {getReviewEncouragementTarget, getPurchaseConfirmationTarget} from '@web/actions/purchaseConfirmation'
import {APIStatus} from '@web/core/constants'
import {type ReceivableRewardState, RewardMethod, getInitialState} from '@web/slices/receivableReward/slice'

import {type ReceivableRewardReducers, type MakeSliceOptions} from './interfaces'

export default (options?: MakeSliceOptions) =>
    createSlice<
        ReceivableRewardState,
        ReceivableRewardReducers,
        'receivableReward',
        SliceSelectors<ReceivableRewardState>
    >({
        name: 'receivableReward',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(getReviewEncouragementTarget.pending, (state) => {
                    state.apiStatus['reviewTarget'] = APIStatus.FETCHING
                })
                .addCase(getPurchaseConfirmationTarget.pending, (state) => {
                    state.apiStatus['confirmationTarget'] = APIStatus.FETCHING
                })
                .addCase(getReviewEncouragementTarget.fulfilled, (state, {payload: {data}}) => {
                    state.reviewableItem = data
                    state.apiStatus['reviewTarget'] = APIStatus.RESOLVED
                })
                .addCase(getPurchaseConfirmationTarget.fulfilled, (state, {payload: {data}}) => {
                    if (data) {
                        state.rewardableItem = {
                            rewardMethod: RewardMethod.AFTER_CONFIRMATION,
                            orderNo: data.orderNo,
                            productOrderNo: data.productOrderNo,
                            productName: data.productName,
                            productImageUrl: data.productImageUrl,
                            expectedRewardAmount: data.expectedPurchaseDecisionRewardPointAmount,
                            isFamilyPay: data.isFamilyPay,
                        }
                    }
                    state.apiStatus['confirmationTarget'] = APIStatus.RESOLVED
                })
                .addCase(getReviewEncouragementTarget.rejected, (state) => {
                    state.apiStatus['reviewTarget'] = APIStatus.REJECTED
                })
                .addCase(getPurchaseConfirmationTarget.rejected, (state) => {
                    state.apiStatus['confirmationTarget'] = APIStatus.REJECTED
                })
            options?.extraReducers?.(builder)
        },
    })
